// src/types/configuracion.ts

// Perfil
export interface Perfil {
  id: string;
  email: string;
  nombre: string;
  apellido?: string;
  telefono?: string;
  avatar_url?: string;
  tipo: 'INTERNO' | 'CLIENTE';
  roles: string[];
  cliente_id?: string;
  cliente?: { id: string; nombre: string };
  activo: boolean;
  ultimo_acceso?: string;
  created_at: string;
}

export interface PerfilUpdate {
  nombre?: string;
  apellido?: string;
  telefono?: string;
}

export interface CambiarPassword {
  password_actual: string;
  password_nuevo: string;
  confirmar_password: string;
}

export interface CambiarAvatar {
  file: File;
}

// Preferencias
export type Tema = 'light' | 'dark' | 'system';

export interface Preferencias {
  tema: Tema;
  notificaciones_email: boolean;
  notificaciones_push: boolean;
  sonido_notificaciones: boolean;
  zona_horaria: string;
  formato_fecha: 'DD/MM/YYYY' | 'MM/DD/YYYY' | 'YYYY-MM-DD';
  formato_hora: '12h' | '24h';
  dashboard_default_id?: string;
  sidebar_colapsado: boolean;
  tabla_filas_por_pagina: number;
}

export const DEFAULT_PREFERENCIAS: Preferencias = {
  tema: 'system',
  notificaciones_email: true,
  notificaciones_push: true,
  sonido_notificaciones: true,
  zona_horaria: 'America/Bogota',
  formato_fecha: 'DD/MM/YYYY',
  formato_hora: '24h',
  sidebar_colapsado: false,
  tabla_filas_por_pagina: 20,
};

// Usuarios (ADMIN) - Extended for configuration page
export interface UsuarioAdmin {
  id: string;
  email: string;
  nombre: string;
  apellido?: string;
  tipo: 'INTERNO' | 'CLIENTE';
  roles: RolAdmin[];
  cliente_id?: string;
  cliente?: { id: string; nombre: string };
  activo: boolean;
  ultimo_acceso?: string;
  created_at: string;
}

export interface UsuarioCreate {
  email: string;
  nombre: string;
  apellido?: string;
  password: string;
  tipo: 'INTERNO' | 'CLIENTE';
  roles: string[];
  cliente_id?: string;
}

export interface UsuarioUpdate {
  nombre?: string;
  apellido?: string;
  tipo?: 'INTERNO' | 'CLIENTE';
  roles?: string[];
  cliente_id?: string;
  activo?: boolean;
}

// Roles - Extended for configuration page
export interface RolAdmin {
  id: string;
  codigo: string;
  nombre: string;
  descripcion?: string;
  permisos: string[];
  es_sistema: boolean;
}

export interface RolCreate {
  codigo: string;
  nombre: string;
  descripcion?: string;
  permisos: string[];
}

// Tipos de Ticket
export interface TipoTicketConfig {
  id: string;
  codigo: string;
  nombre: string;
  descripcion?: string;
  color?: string;
  icono?: string;
  activo: boolean;
  orden: number;
}

// Tipos de Actividad
export interface TipoActividadConfig {
  id: string;
  codigo: string;
  nombre: string;
  color?: string;
  icono?: string;
  area_default?: string;
  aliases?: string[];
  activo: boolean;
}

// Modulos
export interface ModuloConfig {
  id: string;
  codigo: string;
  nombre: string;
  grupo: string;
  orden: number;
  activo: boolean;
}

export interface ModuloCreate {
  codigo: string;
  nombre: string;
  grupo?: string;
  orden?: number;
}

export interface ModuloUpdate {
  codigo?: string;
  nombre?: string;
  grupo?: string;
  orden?: number;
  activo?: boolean;
}

// Categorías de Conocimiento
export interface CategoriaConocimientoConfig {
  id: string;
  nombre: string;
  descripcion?: string;
  icono?: string;
  color?: string;
  orden: number;
  activo: boolean;
}
